<template>
  <div>
    <vxe-toolbar id="invoiceId" :custom="{ storage: true }">
      <template v-slot:buttons>
        <div
          v-if="tableData.length != 0"
          style="display: inline-block; color: firebrick;"
        >
          以下运单实际承运人开票确认不为已通过状态，影响税务开票，是否继续打款？
        </div>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      export-config
      show-overflow
      align="center"
      :loading="loading"
      auto-resize
    >
      <vxe-table-column
        field="orderCode"
        title="运输单号"
        min-width="200"
        sortable
      />
      <vxe-table-column
        field="shippingNoteNumber"
        title="托运单号"
        min-width="120"
        sortable
      />
      <vxe-table-column
        field="driverName"
        title="实际承运人"
        min-width="120"
        sortable
      />
      <vxe-table-column
        field="vehicleLicense"
        title="车牌号"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="driverPhone"
        title="联系方式"
        min-width="160"
        sortable
      />
      <vxe-table-column
        field="coalTypeName"
        title="货物名称"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="billingConfirmationStatus"
        title="开票确认"
        min-width="100"
        :formatter="formatterBillingConfirmationStatus"
      />
      <vxe-table-column
        field="taxInvoiceAmount"
        title="税务开票金额"
        min-width="120"
      />
      <vxe-table-column
        field="plannedContractAmount"
        title="计划合同金额"
        min-width="120"
      />
      <vxe-table-column
        field="deliveryCashFee"
        title="合计收款"
        min-width="100"
      />
      <vxe-table-column field="allotOil" title="油点" min-width="100" />
    </vxe-table>
    <div style="margin-top: 30px;">
      <el-button @click="funcCancel">
        取消打款
      </el-button>
      <el-button type="primary" @click="funcSumbit">
        继续打款
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "BillingConfirm",
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      codes: "",
      formData: {},
      payOnlineItem: "",
      billingConfirmationStatusOptions: [
        { value: 0, label: "未申请" },
        { value: 1, label: "确认中" },
        { value: 2, label: "已通过" },
        { value: 3, label: "未通过" }
      ]
    };
  },

  methods: {
    formatterBillingConfirmationStatus({ cellValue }) {
      const item = this.billingConfirmationStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    verifyBillingConfirmationStatusInfo(
      detailCodes,
      formData,
      responseData,
      payOnlineItem
    ) {
      const rLoading = this.openLoading();
      this.formData = formData;
      this.payOnlineItem = payOnlineItem;
      this.tableData = responseData;
      this.codes = detailCodes;
      rLoading.close();
    },
    funcSumbit() {
      this.$emit("onPayment", this.formData, this.payOnlineItem);
    },
    funcCancel() {
      this.$emit("onHideConfirm");
    }
  }
};
</script>
